import { get, put } from '@/api'

function getDefaultState() {
  return {
    baseSettingsInitialised: false,
    rawSettings: {},
    profileAttributes: {},
    showFilters: false,
  }
}

const state = getDefaultState()

const actions = {
  reset({ state }) {
    Object.assign(state, getDefaultState())
  },
  async fetchSettings({ dispatch }, username) {
    const url = `users/profile/${username}/?format=json`
    let rawSettings = null
    let profileAttributes = null
    try {
      const response = await get(url)
      if (response.status === 200) {
        rawSettings = response.data.settings || null
        profileAttributes = response.data.attributes || null
      }
    } catch (e) {
      console.warn('Failed to fetch user settings, using defaults', e?.message)
    }
    dispatch('setSettings', { rawSettings, profileAttributes })
  },
  async saveSettings({ dispatch }, { username, settings }) {
    const url = `users/profile/${username}/`
    settings = JSON.stringify(settings)
    const response = await put(url, { data: { settings } })
    let newSettings = null
    if (response.status === 200) {
      newSettings = response.data.settings
    }
    return dispatch('setSettings', { rawSettings: newSettings })
  },
  setSettings({ commit }, { profileAttributes, rawSettings }) {
    const settings = {}
    rawSettings = JSON.parse(rawSettings)
    if (rawSettings) settings['rawSettings'] = rawSettings
    if (profileAttributes) settings['profileAttributes'] = profileAttributes
    commit('SET_RAW_SETTINGS', settings)
  },
}

const mutations = {
  SET_RAW_SETTINGS(state, { profileAttributes, rawSettings }) {
    if (profileAttributes) state.profileAttributes = profileAttributes
    if (rawSettings) state.rawSettings = rawSettings
    state.baseSettingsInitialised = true
  },
  SET_SHOW_FILTERS(state, showFilters) {
    state.showFilters = showFilters
  },
  TOGGLE_SHOW_FILTERS(state) {
    state.showFilters = !state.showFilters
  },
}

const getters = {
  rawSettings(state) {
    return state.rawSettings
  },
  profileAttributes(state) {
    return state.profileAttributes
  },
  showFilters(state) {
    return state.showFilters
  },
}

const settings = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}

export default settings
